"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SupportedPhoneNumberTypes = _interopRequireDefault(require("./SupportedPhoneNumberTypes"));

var _SupportedPhoneNumber;

// Supported countries as defined in https://knowledge.hubspot.com/articles/kcs_article/calling/what-countries-are-supported-by-calling
var _default = (_SupportedPhoneNumber = {}, (0, _defineProperty2.default)(_SupportedPhoneNumber, _SupportedPhoneNumberTypes.default.SALES_HUB, ['ar', 'at', 'au', 'cx', 'cc', 'be', 'br', 'bg', 'ca', 'cl', 'cn', 'co', 'cr', 'cz', 'cy', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'in', 'ie', 'il', 'it', 'jp', 'lv', 'lt', 'lu', 'mt', 'mx', 'nl', 'nz', 'no', 'pa', 'pe', 'pl', 'pt', 'ro', 'sg', 'sk', 'za', 'kr', 'es', 'se', 'ch', 'gb', 'us']), (0, _defineProperty2.default)(_SupportedPhoneNumber, _SupportedPhoneNumberTypes.default.CRM, ['au', 'br', 'fr', 'de', 'ie', 'jp', 'es', 'gb', 'us']), _SupportedPhoneNumber);

exports.default = _default;
module.exports = exports.default;